import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from '../../utils/axios';
import {
  createOrganizationFailure,
  createOrganizationRequest,
  createOrganizationSuccess,
  editOrganizationFailure,
  editOrganizationRequest,
  editOrganizationSuccess,
  fetchOrganizationById,
  fetchOrganizationByIdFailure,
  fetchOrganizationByIdSuccess,
  fetchOrganizationsFailure,
  fetchOrganizationsRequest,
  fetchOrganizationsSuccess,
} from './organizationSlice';
import { isEmpty } from 'lodash';

function* fetchOrganizationsSaga(action) {
  try {
    const { email, page, limit, search_by, search_key, only_individuals } = action.payload;
    const params = {
      page,
      limit,
      email,
      only_individuals,
    };
    if (!isEmpty(search_key) && !isEmpty(search_by)) {
      params[search_by] = search_key;
    }
    const response = yield call(axiosInstance.get, '/organizations', { params });
    yield put(fetchOrganizationsSuccess(response.data));
  } catch (error) {
    yield put(fetchOrganizationsFailure(error.message));
  }
}

function* fetchOrganizationByIdSaga(action) {
  try {
    const response = yield call(axiosInstance.get, `/organizations/${action.payload}`);
    yield put(fetchOrganizationByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchOrganizationByIdFailure(error.message));
  }
}

function* editOrganizationRequestSaga(action) {
  try {
    const { _id, __v, createdAt, updatedAt, ...sanitizedPayload } = action.payload;
    const response = yield call(axiosInstance.put, `/organizations/${_id}`, sanitizedPayload);
    yield put(editOrganizationSuccess(response.data));
  } catch (error) {
    yield put(editOrganizationFailure(error.response.data.error));
  }
}

function* createOrganizationSaga(action) {
  try {
    const response = yield call(axiosInstance.post, '/organizations', action.payload);
    yield put(createOrganizationSuccess(response.data));
  } catch (error) {
    yield put(createOrganizationFailure(error.response.data.errors));
  }
}

function* organizationSaga() {
  yield takeLatest(fetchOrganizationsRequest.type, fetchOrganizationsSaga);
  yield takeEvery(fetchOrganizationById.type, fetchOrganizationByIdSaga);
  yield takeLatest(createOrganizationRequest.type, createOrganizationSaga);
  yield takeLatest(editOrganizationRequest.type, editOrganizationRequestSaga);
}

export default organizationSaga;
